import styled from "styled-components";

export const Container = styled.div`
  color: var(--dark-grey);
  font-size: 12px;
  line-height: 14px;

  .ant-badge-status-dot {
    height: 14px;
    width: 14px;
  }
  .ant-badge-status-text {
    display: none;
  }

  .ant-space {
    width: 100%;
  }

  .ant-typography {
    white-space: pre-wrap;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const CardContainer = styled.div`
  height: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-self: center;

  svg {
    color: #57575740;
    ${CardContainer}:not(:hover) & {
      display: none;
    }
  }
`;

export const FloatActionsContainer = styled.div`
  float: right;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-self: center;

  svg {
    color: #57575740;
    ${CardContainer}:not(:hover) & {
      display: none;
    }
  }
`;
